import { default as MuiBreadcrumbs } from '@mui/material/Breadcrumbs';

/**
 * Breadcrumbs are a navigation system used to show hierarchy and context within the product experience.
 *
 * Demos:
 *
 * - [Breadcrumbs](https://unify.workiva.org/components/breadcrumbs?tab=code)
 *
 * API:
 *
 * - [Breadcrumbs API](https://unify.workiva.org/components/breadcrumbs?tab=props#breadcrumbs)
 */
export const Breadcrumbs = MuiBreadcrumbs;
export {
  type BreadcrumbsProps,
  breadcrumbsClasses,
} from '@mui/material/Breadcrumbs';
